import { useCallback, useRef } from 'react';
import { getPersistedTableConfig } from '@components/common/DataGrid';

interface UseGridPersistenceOptions {
  defaultOrderBy?: string[];
}

export const useGridPersistence = (tableName: string, options?: UseGridPersistenceOptions) => {
  const persisted = getPersistedTableConfig(tableName);
  const defaultOrderBy = options?.defaultOrderBy || [];

  const orderByRef = useRef<string[]>(persisted?.orderBy || defaultOrderBy);
  const gridODataFilterRef = useRef<string | null>(persisted?.oDataFilter || null);

  const handleGridSearchParams = useCallback(({ orderBy, oDataFilter }: { orderBy?: string[]; oDataFilter?: string | null }) => {
    if (orderBy !== undefined) {
      orderByRef.current = orderBy.length ? orderBy : defaultOrderBy;
    }
    if (oDataFilter !== undefined) {
      gridODataFilterRef.current = oDataFilter;
    }
  }, []);

  return { orderByRef, gridODataFilterRef, handleGridSearchParams };
};
